module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "disabled": _vm.disabled,
      "items": _vm.rasters,
      "item-text": "displayName",
      "prepend-inner-icon": "nature",
      "append-icon": "keyboard_arrow_down",
      "return-object": "",
      "persistent-hint": "",
      "hint": ((_vm.$t('selecciona.raster')) + " " + (_vm.indicador ? _vm.$t(("indicadores." + _vm.indicador)) : ''))
    },
    model: {
      value: (_vm.raster),
      callback: function($$v) {
        _vm.raster = $$v
      },
      expression: "raster"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-130601c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/utils/shared-components/select-raster.vue
// module id = 1043
// module chunks = 1